// src/types/analysis.ts
var DEFAULT_OG_CARD_CONFIG = {
  showScore: true,
  showSummary: true,
  maxSummaryLength: 160,
  footerText: null
};
var DEFAULT_SHARE_FORMAT = "reel";

export {
  DEFAULT_OG_CARD_CONFIG,
  DEFAULT_SHARE_FORMAT
};
